/**
 * Cierre con validación — helpers PUROS de la UI, portados de silvai-chat (S-01).
 *
 * Con la validación encendida en el negocio, el técnico cierra EN SITIO (modelo
 * + número de serie + resultado) y el trabajo queda "Por validar"; supervisión
 * completa lo COMERCIAL desde el panel y recién ahí queda cerrado en firme.
 *
 * Las reglas duras viven en el backend; esto es para que la pantalla diga QUÉ
 * FALTA antes de que alguien apriete el botón, en llano.
 */

/** Datos del cierre que mira la validación de supervisión. */
export interface CierreComercial {
  esGarantia: boolean;
  requiereComprobanteFiscal: boolean;
  montoCierre?: number | null;
  formaPago?: string | null;
  vendedorUserId?: string | null;
  rnc?: string | null;
  comprobanteFiscal?: string | null;
}

/** ¿Hay texto real (no solo espacios)? */
const lleno = (v?: string | null): boolean => typeof v === 'string' && v.trim() !== '';

/**
 * Qué le falta al trabajo para cerrarse en firme, en el idioma del dueño. [] si
 * no falta nada. Las GARANTÍAS no llevan monto/pago/vendedor (no hay venta); el
 * comprobante fiscal es aparte: si el cliente lo pidió, hace falta igual.
 */
export function camposFaltantesValidacion(cierre: CierreComercial): string[] {
  const faltan: string[] = [];

  if (!cierre.esGarantia) {
    // Un monto de 0 es un monto: solo falta si viene vacío.
    if (cierre.montoCierre == null || !Number.isFinite(cierre.montoCierre)) {
      faltan.push('el monto cobrado');
    }
    if (!lleno(cierre.formaPago)) faltan.push('la forma de pago');
    if (!lleno(cierre.vendedorUserId)) faltan.push('el vendedor');
  }

  if (cierre.requiereComprobanteFiscal) {
    if (!lleno(cierre.rnc)) faltan.push('el RNC del cliente');
    if (!lleno(cierre.comprobanteFiscal)) faltan.push('el número de comprobante fiscal');
  }

  return faltan;
}

/** ¿Supervisión ya puede cerrar el trabajo en firme? */
export function puedeValidar(cierre: CierreComercial): boolean {
  return camposFaltantesValidacion(cierre).length === 0;
}

/** Lo que el TÉCNICO tiene que llenar en sitio para poder cerrar. */
export interface CierreEnSitio {
  modelo: string;
  numeroSerie: string;
  resultado: string;
}

/** ¿El técnico ya puede apretar "Terminé"? */
export function puedeCerrarEnSitio(cierre: CierreEnSitio): boolean {
  return lleno(cierre.modelo) && lleno(cierre.numeroSerie) && lleno(cierre.resultado);
}

/**
 * Período de cobertura en el idioma del dueño. Se guarda en MESES (permite la
 * fecha exacta), pero cuando cierra en años redondos se muestran los dos.
 */
export function etiquetaCobertura(meses: number): string {
  if (meses === 1) return '1 mes de garantía';
  if (meses % 12 === 0) {
    const anios = meses / 12;
    return `${meses} meses (${anios} ${anios === 1 ? 'año' : 'años'}) de garantía`;
  }
  return `${meses} meses de garantía`;
}
